import { HttpInterceptorFn } from '@angular/common/http';

/**
 * Make each outgoing request be with credentials (cookies)
 */
export const credentialsInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req.clone({ withCredentials: true }));
};